import {
    SEARCH_PARAMETER,
    SEARCH_RESULTS_SUCCESS,
    SELECTED_OPTION,
    SEARCH_SECTION_TEMPLATE,
    OVERRIDDING_RISKFACTOR_SEARCH,
    SCORECARD_SEARCH
} from './action';
const initialState = {
    searchKey: null,
    searchResults: null,
    selectedOption: null
};
const autoSuggestReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_PARAMETER:
            return state = {
                ...state,
                searchKey: action.data
            }
        case SEARCH_SECTION_TEMPLATE:
            return state = {
                ...state,
                searchKey: action.data
            }
        case SCORECARD_SEARCH:
            return state = {
                ...state,
                searchKey: action.data
            }
        case OVERRIDDING_RISKFACTOR_SEARCH:
            return state = {
                ...state,
                searchKey: action.data
            }
        case SEARCH_RESULTS_SUCCESS:
            return state = {
                ...state,
                searchResults: action.data
            }
        case SELECTED_OPTION:
            return state = {
                ...state,
                selectedOption: action.data
            }
        default:
            return state
    }
}
export default autoSuggestReducer; 